// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc981098","453":"d0127db0","732":"474668aa","977":"add7dabd"}[chunkId] + ".chunk.js";
};